import React from 'react';

export default function SwitchOnIcon() {
	return (
		<svg width="53"
			height="32"
			viewBox="0 0 53 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5"
				width="52"
				height="32"
				rx="16"
				fill="url(#paint0_linear_3259_53214)"/>
			<rect x="24.5"
				y="4"
				width="24"
				height="24"
				rx="12"
				fill="black"/>
			<defs>
				<linearGradient id="paint0_linear_3259_53214"
					x1="26.5"
					y1="-13.2308"
					x2="-1.96479"
					y2="-10.5926"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#B3FE00"/>
					<stop offset="1"
						stopColor="#00F644"/>
				</linearGradient>
			</defs>
		</svg>
    
	);
}
